import { h } from 'preact';
import style from './style.scss';
import { Btn, ControlBtn } from "../call-btn";

import { apiRoot } from "../../../api/index";
import { chatBtns } from '../../../utils/consts'

import { langPack } from '../../../utils/langPack';


const Call = ({
    communicateModal = {}, rejectCall, pickUp, locale, ...props
}) => {
    const { person = {}, isIncoming, isOutcoming, isBusy, isCalling, callInfo = {}, isSpeaking }  = communicateModal;
    const {error, info } = callInfo;

    const { nickname, pro, avatar } = person;


    const fullName = nickname;
    const title = isSpeaking ? langPack[locale].COMMUNICATION.ON_CALL_WITH
            : isCalling ? langPack[locale].COMMUNICATION.CONNECTING_WITH
                : isOutcoming ? langPack[locale].MISC.CALLING_PRO : isIncoming ? langPack[locale].COMMUNICATION.INCOMING_CALL : '';
    const descr = isIncoming ? langPack[locale].COMMUNICATION.YOUR_CLIENT : pro && pro.profession;
    const _info = error ? info : '';

    const btns = isIncoming ? [{
            txt: chatBtns.decline,
            handler: (e) => rejectCall(true),
        }, {
            txt: chatBtns.pickUp,
            handler: pickUp
        }] : [];


    const avatarEl = (
        <div class={style.avatar}> { avatar ? (
                <img src={apiRoot + 'image/' + avatar.id} alt={fullName} title={fullName} />
            ) : (
                <img src="/assets/nouserimage.jpg" alt={fullName} title={fullName}/>
            )}
        </div>);

    return (
        <div class={style.callComponent}>
            <div className={style.title}>{title}</div>

            <div style={{position: 'relative'}}>
              { !(isSpeaking) && avatarEl }
            </div>
            <div>
                <div class={style.name}>{fullName}</div>
                <div className={style.descr}>{descr}</div>
            </div>

            <div class={style.info}>{_info}</div>

            <div class={style.btnArea}>
                {props.isConnected ?
                    btns.map(el => <Btn text={el.txt} key={el.txt} clickHandler={el.handler}/>) : langPack[locale].MISC.CONNECTING_TO_SERVER }
            </div>

        </div>
    )
};

export default Call;



// WEBPACK FOOTER //
// ./components/communication/call/index.js